// ============================================
// ROLE DEFINITIONS
// ============================================

export const ROLES = {
  ADMIN: "Admin",
  SPOC: "Spoc",
  FINANCE: "Finance",
};

// Pages each role can access
export const ROLE_PAGES = {
  [ROLES.ADMIN]: [
    "dashboard",
    "create-new",
    "all-list",
    "renewal",
    "parent-code",
    "tat-history",
    "upload-excel",
    "spoc-management",
  ],
  [ROLES.SPOC]: [
    "dashboard",
    "create-new",
    "all-list",
    "parent-code",
    // "tat-history"
  ],
  [ROLES.FINANCE]: [
    "dashboard",
    // "create-new",
    "all-list",
    // "Company-and-distributor",
    "tat-history",
  ],
};

// Granular permissions per role
// Admin   — full access: create, view, edit, update, approve, deficiency
// Spoc    — create + view all-list (view only, no edit/approve/deficiency)
// Finance — view all-list only (no create, no edit, no approve, no deficiency)
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: {
    canCreate: true,
    canEdit: true, // edit icon + editable modal fields
    canUpdate: true, // Update button
    canApprove: true, // Approve button
    canDeficiency: true, // Deficiency button
    canDelete: true,
    canResend: true, // resend KYC link
    isReadOnly: false,
    isFinance: false,
    canViewlogs: true,
    isViewAdharNumber: true,
    isEditAdharNumber: true,
    isTATView: true,
    isCanViewTatGraph: true,
  },
  [ROLES.SPOC]: {
    canCreate: true,
    canEdit: true, // edit icon + editable modal fields
    canUpdate: true, // Update button
    canApprove: false,
    canDeficiency: false,
    canDelete: false,
    canResend: false,
    isReadOnly: false, // fields are editable
    canViewlogs: true,
    isViewAdharNumber: false,
    isEditAdharNumber: false,
    isTATView: false,
    isCanViewTatGraph: false,
  },
  [ROLES.FINANCE]: {
    canCreate: false,
    canEdit: false,
    canUpdate: false,
    canApprove: false,
    canDeficiency: false,
    canDelete: false,
    canResend: false,
    isReadOnly: true,
    isFinance: true,
    defaultApproveStatus: "true",
    canViewlogs: true,
    isViewAdharNumber: false,
    isEditAdharNumber: false,
    isTATView: false,
    isCanViewTatGraph: false,
  },
};

const DEFAULT_PERMISSIONS = {
  canCreate: false,
  canEdit: false,
  canUpdate: false,
  canApprove: false,
  canDeficiency: false,
  canDelete: false,
  canResend: false,
  isReadOnly: true,
};

export const getPermissions = (role) =>
  ROLE_PERMISSIONS[role] || DEFAULT_PERMISSIONS;

export const canAccessPage = (role, page) =>
  (ROLE_PAGES[role] || []).includes(page);
